import { EventEmitter } from 'events';
import dispatcher from '../dispatcher.js';

class LoginStore extends EventEmitter {
	constructor() {
		super();
		this.email = {
			value: '',
			class: '',
			message: ''
		};
		this.password = {
			value: '',
			class: '',
			message: ''
		};
		this.user = false;
	}


	getAll() {
		return {
			email: this.email,
			password: this.password
		}
	}

	getUser() {
		return this.user;
	}

	setEmail(newEmail) {
		this.email.value = newEmail;
	}

	addMessageError(message = 'Email o password non corretta') {
		this.password.class = 'is-warning';
		this.email.class = 'is-warning';
		this.email.message = message;
	}

	validateEmail(newEmail) {
		if(!newEmail) {
			this.email.class = 'is-danger';
			this.email.message = 'Campo obbligatorio';
			return;
		}
		// eslint-disable-next-line
	    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    if(re.test(newEmail.toLowerCase())) {
			this.email.class = 'is-success';
			this.email.message = '';
	    } else {
			this.email.class = 'is-warning';
			this.email.message = 'Email non valida';
	    }
	}

	setPassword(newPassword) {
		this.password.value = newPassword;
	}

	validatePassword(newPassword) {
		if(!newPassword){
			this.password.class = 'is-danger';
			this.password.message = 'Campo obbligatorio';
			return;
		}
		if(newPassword.length > 7) {
			this.password.class = 'is-success';
			this.password.message = '';			
		} else {
			this.password.class = 'is-warning';
			this.password.message = 'Password troppo corta';						
		}
	}

	handleAction(action) {
		switch(action.type) {
			case 'set_email':
				this.setEmail(action.email);
				this.emit("change");
			break;
			case 'validate_email':
				this.validateEmail(action.email);
				this.emit("change");
			break;
			case 'set_password':
				this.setPassword(action.email);
				this.emit("change");
			break;
			case 'validate_password':
				this.validatePassword(action.email);
				this.emit("change");
			break;
			case 'wrongUserPassword':
				this.addMessageError();
				this.emit("change");
			break;
			case 'invalidPasswordSubmitted':
				this.addMessageError('É richiesta una password alfanumerica con almeno un carattere maiuscolo/minuscolo ');
				this.emit("change");
			break;
			case 'userExist':
				this.addMessageError('Esiste già un utente con questa email');
				this.emit("change");
			break;
			case 'user_logged':
				this.email = {
					value: '',
					class: '',
					message: ''
				};
				this.password = {
					value: '',
					class: '',
					message: ''
				};
			break;
			case 'reset_status':
			if(this.email.class !== 'is-success' || this.password.class !== 'is-success') {
				this.email = {
					value: '',
					class: '',
					message: ''
				};
				this.password = {
					value: '',
					class: '',
					message: ''
				};
			}
			break;
			case 'user_confirmPassword':
				this.user = action.user;
			break;
			default:
			break;
		}
	}
}

const loginStore = new LoginStore();
dispatcher.register(loginStore.handleAction.bind(loginStore));

export default loginStore;


// WEBPACK FOOTER //
// ./src/stores/login-store.js